import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {getDisplaySizeIdError} from '../../utils/productReviewValidation'
import {PRODUCT_REVIEW_ADDITIONAL_INFORMATION_SECTION} from '../productReviewDataMap'

export const AdditionalInformationSection = () => {
  const {productData} = useProductReview()
  const displaySizeIdError = getDisplaySizeIdError(productData?.additionalInfo?.displaySizeId)

  return (
    <ProductReviewSection title="Additional Information" icon="info">
      <ProductReviewData
        sections={[PRODUCT_REVIEW_ADDITIONAL_INFORMATION_SECTION]}
        fieldErrors={displaySizeIdError ? {'additionalInfo.displaySizeId': displaySizeIdError} : {}}
      />
    </ProductReviewSection>
  )
}
